










import {Component, Prop, Vue} from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import {AvailablePeriodType} from "@/data/models/enums/available-period-type";

@Component({components: {apexchart: VueApexCharts}})
export default class ConsumptionChart extends Vue {
  @Prop({required: true})
  series: { unit: string, data: ApexAxisChartSeries };

  @Prop({default: false})
  loadingData: boolean;

  @Prop({required: true})
  isListDisplay: boolean;

  @Prop({required: true})
  period: AvailablePeriodType;

  get periodLabel(): string {
    return this.$t(`consumptionPeriodLabel.${this.period}`).toString();
  }

  get seriesSorted(): ApexAxisChartSeries {
    let sorted = this.series.data.sort((a, b) => a.name.localeCompare(b.name));

    // Si l'ensemble des série ont des valeurs, on retourne directement le tableau
    if (sorted.every(it => it.data.length > 0)) {
      return sorted;
    }

    // La série avec des valeurs doit toujours être en premier dans le tableau
    sorted.sort((a, b) => {
      if (a.data.length === 0) {
        return 1;
      } else if (b.data.length === 0) {
        return -1;
      } else {
        return 0;
      }
    });

    return sorted;
  }

  get getMaxYKw(): number {
    let max = 0;
    this.series.data.forEach(it => {
      it.data.forEach(elem => {
        if (elem.y > max) {
          max = elem.y;
        }
      })
    })

    return max;
  }

  get fractionDigits(): number {
    if (this.series.data.length > 1 && this.getMaxYKw < 0.5) {
      return 6;
    } else if (this.getMaxYKw < 0.1) {
      return 4
    } else {
      return 2
    }
  }

  get yaxis(): any[] {

    const foundMeterType = [];

    // Génération de l'axe Y en fonction des series
    return this.seriesSorted.map((it) => {
      let isTemperature = false;
      try {
        isTemperature = it['meterType'].includes('TEMPERATURE');
      } catch (error) {
        isTemperature = false;
      }
      let isVisible = true;

      // On ne veut pas afficher plusieurs fois la même unité
      if(!foundMeterType.includes(isTemperature ? 'TEMPERATURE' : it['unit'])) {
        foundMeterType.push(isTemperature ? 'TEMPERATURE' : it['unit']);
      } else {
        // On ne veut pas afficher les unités qui sont déjà affichées
        isVisible = false;
      }

      // Format unit using i18n
      const unitText = this.$t(`meter.unitsValue.${it['unit']}`).toString();

      if(it['unit'] == "degree"){
        it['unit'] = "°C";
      }

      let displayName = it.name;
      if (isTemperature) {
        displayName = "Température (°C)";
      } else {
        displayName = `Consommation (${unitText})`;
      }

      return {
        seriesName: it.name,
        show: isVisible,
        min: !isTemperature ? 0 : -10,
        max: !isTemperature ? this.getMaxYKw : 30,
        opposite: isTemperature,
        title: {
          text: displayName
        },
        labels: {
          formatter: (val) => `${!isTemperature ? (val || 0).toFixed(this.fractionDigits) : (val || 0).toFixed(2)}`,
        }
      }
    });
  }

  get options(): ApexCharts.ApexOptions {
    return {
      chart: {
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      fill: {
        type: 'solid',
      },
      markers: {
        size: 5,
      },
      tooltip: {
        fixed: {
          enabled: true,
          position: "topLeft",
          offsetY: 30,
          offsetX: 60
        }
      },
      yaxis: this.yaxis,
      xaxis: {
        tooltip: {
          enabled: false,
        },
      },
    };
  }
}
